import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Edit from 'components/user/profile/modal/edit';

const EditButton = ({ user, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      variant="contained"
      onClick={() =>
        addModal(
          <Edit
            user={user}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.user.profile.edited');
            }}
            handleClose={() => {
              removeModal();
            }}
          />,
          { disableAutoFocus: true, disableRestoreFocus: true }
        )
      }
    >
      <FormattedMessage id="button.edit" />
    </Button>
  );
};

export default EditButton;
